export default __webpack_public_path__ + "static/media/promotion.298a26b3.svg";